module.exports = __webpack_public_path__ + "static/img/3-he-1-da-zhuan-yun-fa.a99ea26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/3-he-1-da-zhuan-yun-fa.jpg
// module id = KJDS
// module chunks = 1